import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface Props {
  children: any,
}

const TopRow = (props: Props) => {
  const {
    children,
  } = props;

  const styles: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
  };
  return (
    <div style={styles}>
      {children}
    </div>
  );
};

export default TopRow;
